import React, {useState} from 'react';
import {confirmEmailText} from '../confirmEmailText';
import {internalErrorCodes} from '../../../../data/errorCodes';
import styles from './ConfirmEmailUI.module.css';
import RetryButton from '../../../../uiToolkit/Buttons/RetryButton';
import Button from '../../../../uiToolkit/Buttons/Button';
import TextInput2 from '../../../../uiToolkit/Inputs/TextInput2/TextInput2';
import FormattedText from '../../../../uiToolkit/FormattedText/FormattedText';
import ErrorBox2 from '../../../../uiToolkit/ErrorBox2/ErrorBox2';

interface Props {
  errors: string[];
  onConfirmEmail: (code: string) => void;
  onRetry: () => void;
  isLoading: boolean;
  // onBack: () => void;
  clearErorrs: () => void;
}

const ConfirmEmailUI = React.memo(
  ({
    errors,
    onConfirmEmail,
    onRetry,
    isLoading,
    // onBack,
    clearErorrs,
  }: Props) => {
    const [code, setCode] = useState('');
    const [internalErrors, setInternalErrors] = useState<string[]>([]);

    const onSubmit = () => {
      if (code !== '') {
        onConfirmEmail(code);
      } else {
        setInternalErrors([internalErrorCodes.PROVIDE_VERIFICATION_CODE]);
      }
    };

    const onClearErrors = () => {
      setInternalErrors([]);
      clearErorrs();
    };

    return (
      <>
        {/* <button className="EmailBackButton" onClick={onBack}>
            <span className="icon-typeArrow-down"></span>
            {confirmEmailText.goBack}
          </button> */}
        <h2 className={styles.pageTitle}>
          <FormattedText text={confirmEmailText.title} />
        </h2>
        <TextInput2
          type="text"
          value={code}
          onChange={setCode}
          label={confirmEmailText.code}
          placeholder={confirmEmailText.codePlaceholder}
          isMandatory={true}
          uiType="minimal"
          className={styles.inputControl}
        />
        <ErrorBox2
          errorCodes={[...errors, ...internalErrors]}
          clearErrors={onClearErrors}
          className={styles.errorBox}
          uiType="minimal"
        />
        <Button
          title={confirmEmailText.submit}
          onClick={onSubmit}
          disabled={code.trim() === ''}
          isLoading={isLoading}
          uiType="signup"
          className={styles.button}
        />
        <RetryButton onRetry={onRetry} title={confirmEmailText.didntGetACode} />
      </>
    );
  },
);

export default ConfirmEmailUI;
